<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name:'ranking'
    }
</script>

<style lang="scss" scoped>

</style>